module.exports = __webpack_public_path__ + "media/images/icons/double-quote-serif-right-a4420001e3d31671f09c50be44a26a06.svg";